export const RESUME = {
    title: "Resume",
    subtitle: "My",
    typeWriter: ["Education", "Experience"],
    education: [
        {
            year: "2018 - 2022",
            institution: "Naogaon Polytechnic Institute",
            subject: "Diploma in Electrical Engineering",
            description: "Completed a Diploma in Electrical Engineering, gaining problem-solving and analytical skills."
        },
        {
            year: "2016 - 2018",
            institution: "Shibpur High School",
            subject: "SSC in Humanities",
            description: "Completed my SSC in Humanities, developing strong communication and research abilities."
        }
    ],
    experience: [
        {
            year: "2023 - Present",
            company: "Tawab IT Ltd",
            role: "Lead Generation Manager",
            description: "Managing B2B lead generation, email outreach campaigns, and prospect research to drive business growth."
        },
        {
            year: "2022 - 2023",
            company: "Freelance",
            role: "Lead Generation Specialist",
            description: "Worked with international clients to provide high-quality B2B leads, targeted email lists, and LinkedIn prospecting services."
        }
    ],
    skills: [
        {
            name: "Lead Generation",
            parentage: 95
        },
        {
            name: "B2B Marketing",
            parentage: 90
        },
        {
            name: "Email Outreach",
            parentage: 95
        },
        {
            name: "LinkedIn Prospecting",
            parentage: 85
        },
        {
            name: "CRM Management",
            parentage: 85
        },
        {
            name: "Cold Emailing",
            parentage: 90
        },
        {
            name: "Sales Funnel Optimization",
            parentage: 80
        },
        {
            name: "Market Research",
            parentage: 85
        },
        {
            name: "Data Analysis",
            parentage: 85
        }
    ]
}
